import { dispatch } from '../store/state';
import _ from 'lodash';
import { checkObjectKeyValues } from '.';

export const SyncCampiagnData = (
  state,
  brandId,
  defaultSet,
  incoming,
  options,
) => {
  // const defSet = _defSet;
  const _state = state;
  _state.brand = brandId; // updating id
  _state.campaignid = incoming.campaignid || '';
  // note: making keys array from defaultSet object

  const _passed = [];
  for (const [key] of Object.entries(defaultSet)) {
    _passed.push(key);
  }
  // note: filter object with above _pushed keys
  // console.log("incoming", incoming);
  const _actualIncoming = Object.keys(incoming.data)
    .filter((key) => _passed.includes(key))
    .reduce((obj, key) => {
      obj[key] = incoming.data[key];
      return obj;
    }, {});

  const _filtered = checkObjectKeyValues(_actualIncoming); // clearing unwated fields

  const _final = { ..._state, ..._filtered }; // merging new data with old fields

  // correction in deliverables array of object picking only needed
  const _toClean = _final.deliverables;
  let _cleanedDeliverables;
  // console.log("toclean", _toClean);
  if (_toClean && _toClean.length) {
    console.log('in cleaning');
    _cleanedDeliverables = _toClean.map((delv) => {
      const _v = {
        format: delv.format,
        creatives: delv.creatives,
        assets: delv.assets.map((asset) => {
          const _v_a = {
            filename: asset.name || asset.filename,
            mime: asset.mime,
            url: asset.url,
            size: asset.size,
          };
          // delete asset.name;
          // delete asset.key;
          // delete asset.uid;
          // return _.pick(asset, _.keys(assetModel));
          return _v_a;
        }),
      };
      return _v;
    });
    _final.deliverables = _cleanedDeliverables;
    console.log('correction check', _cleanedDeliverables);
  } else {
    // console.log("correction not checked", _cleanedDeliverables);
    // _cleanedDeliverables = _final.deliverables;
    // _cleanedDeliverables = [];
    // _final.deliverables = [];
  }

  console.log('final', _final);
  return new Promise((resolve, reject) => {
    if (!incoming.returnOnly) {
      dispatch({
        type: 'CREATE_CAMP_DATA',
        payload: {
          ..._final,
          deliverables: incoming.data.deliverables || [], // dedicated push for deep obejct correction
        },
      });
    }
    resolve(_final);
    // resolve(_final);
  });
};
